import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
   CSidebar,
   CSidebarBrand,
   CSidebarNav,
   CSidebarToggler,
   CSidebarHeader,
   CCloseButton,
   CSidebarFooter,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import '@coreui/coreui/dist/css/coreui.min.css';
import { AppSidebarNav } from './AppSidebarNav';
import { getObjectData } from '../services/Storage';
import jwt_decode from 'jwt-decode';

import { logoNegative } from '../assets/brand/logo-negative';

import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';

// sidebar nav config
// import navigation from '../_nav'
import { _nav, _adminNav } from '../_nav';

const AppSidebar = () => {
   const dispatch = useDispatch();
   const unfoldable = useSelector((state) => state.sidebarUnfoldable);
   const sidebarShow = useSelector((state) => state.sidebarShow);

   const [user, setUser] = useState(null);

   useEffect(() => {
      getUserDetails();
   }, []);

   const getUserDetails = async () => {
      try {
         const tokenData = await getObjectData('auth');
         const userData = jwt_decode(tokenData.accessToken);
         if (userData) {
            setUser(userData);
         }
      } catch (error) {
         setUser(null);
      }
   };

   return (
      <CSidebar
         className="border-end"
         colorScheme="light"
         position="fixed"
         unfoldable={unfoldable}
         visible={sidebarShow}
         onVisibleChange={(visible) => {
            dispatch({ type: 'set', sidebarShow: visible });
         }}
      >
         <CSidebarHeader className="border-bottom">
            <CSidebarBrand to="/">
               {/* Removed logo image */}
               {/* <CIcon customClassName="sidebar-brand-narrow" icon={sygnet} height={32} /> */}
            </CSidebarBrand>
            <CCloseButton
               className="d-lg-none"
               dark
               onClick={() => dispatch({ type: 'set', sidebarShow: false })}
            />
         </CSidebarHeader>
         <CSidebarNav>
            <SimpleBar>
               {user && user.roles.includes('Station Admin') ? (
                  <AppSidebarNav items={_adminNav} />
               ) : (
                  <AppSidebarNav items={_nav} />
               )}
            </SimpleBar>
         </CSidebarNav>

         <CSidebarFooter className="border-top d-none d-lg-flex mb-4">
            {/* <CSidebarToggler
               onClick={() =>
                  dispatch({ type: 'set', sidebarUnfoldable: !unfoldable })
               }
            /> */}
         </CSidebarFooter>
      </CSidebar>
   );
};

export default React.memo(AppSidebar);
